import { connect } from "react-redux";

import AnswerComplete from "components/answer/AnswerComplete";
import { openErrorDialog } from "redux/modules/errorDialog";

import history from "utils/history";

const mapStateToProps = state => ({
  answerHeader: state.answerHeader,
  locale: state.answerResult.locale
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  showErrorDialog: () => {
    dispatch(openErrorDialog(new Error("invalidOperation")));
  },
  handleReturn: () => {
    setTimeout(() => history.push("/start", ownProps), 300);
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(AnswerComplete);



// WEBPACK FOOTER //
// ./src/containers/preview/AnswerCompleteContainer.jsx